import { useAuth } from '@/features/auth/components/AuthListener'
import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const lines = [
    'INT. NIGHT — A WRITER SITS IN SILENCE...',
    'THE CURSOR BLINKS.',
    'THE STORY BEGINS.',
    'A UNIVERSE IS WRITTEN.',
    'FADE IN...',
]

const StoryverseLanding = () => {
    const [displayedText, setDisplayedText] = useState('')
    const [lineIndex, setLineIndex] = useState(0)
    const [charIndex, setCharIndex] = useState(0)

    useEffect(() => {
        const line = lines[lineIndex]

        if (charIndex < line.length) {
            const timeout = setTimeout(() => {
                setDisplayedText((prev) => prev + line[charIndex])
                setCharIndex(charIndex + 1)
            }, 50)
            return () => clearTimeout(timeout)
        } else {
            const pause = setTimeout(() => {
                setDisplayedText('')
                setCharIndex(0)
                setLineIndex((prev) => (prev + 1) % lines.length) // loop forever
            }, 2000)
            return () => clearTimeout(pause)
        }
    }, [charIndex, lineIndex])
    const { user } = useAuth()
    const router = useNavigate()
    const handleRouting = () => {
        if (user) {
            router('/dashboard')
        } else {
            router('/login')
        }
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#070d1f] via-[#0B1D3A] to-[#0a1938] text-white relative overflow-hidden flex flex-col items-center justify-center px-6">
            {/* Starfield background */}
            <div className="absolute inset-0 -z-10 pointer-events-none">
                <div className="w-full h-full bg-black opacity-30 bg-[radial-gradient(ellipse_at_top,rgba(255,255,255,0.1),transparent)] animate-pulse" />
                <div className="absolute inset-0 bg-[url('/film-grain.png')] mix-blend-overlay opacity-[0.03]" />
                <div className="absolute inset-0 bg-[url('/stars.svg')] animate-slowSpin opacity-10" />
            </div>

            {/* Glowing Logo */}
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 1 }}
                className="flex items-center gap-4 mb-12"
            >
                <img
                    src="/storyverse.svg"
                    alt="Storyverse Logo"
                    className="h-20 w-20 brightness-0 invert drop-shadow-[0_0_25px_rgba(255,255,255,0.7)]"
                />
                <h1 className="text-5xl font-bold font-mono drop-shadow-lg tracking-wide">
                    Storyverse
                </h1>
            </motion.div>

            {/* Infinite typewriter */}
            <div className="text-xl font-mono min-h-[3rem] text-center text-gray-200">
                <span>{displayedText}</span>
                <span className="animate-blink">|</span>
            </div>

            {/* Call-to-action */}
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 1, duration: 0.5 }}
                className="mt-16"
            >
                <button
                    onClick={handleRouting}
                    className="bg-white cursor-pointer text-[#0B1D3A] px-8 py-4 rounded-full font-bold text-lg shadow-2xl hover:bg-gray-100 transition-all"
                >
                    Begin your Storyverse
                </button>
            </motion.div>
        </div>
    )
}

export default StoryverseLanding
